export default "__VITE_ASSET__CICMrVdZ__"